import React from 'react';
import { KoobCard, KoobPlaceholder } from '@koob/ui';
import DocumentListItem from './DocumentListItem';
import { getBookingDocument } from 'api/node/bookings';
import { decodeId } from 'utils';
import { getTripDocument } from 'api/node/tripConversation';
import { getBookingDocumentBySecret } from 'api/node/hotelkeeper';

export default function DocumentList({
  documents,
  bookingId,
  tripId,
  conversationId,
  secret,
  isTrip = false,
}) {
  const getDocument = (documentId) => {
    if (isTrip || secret) {
      return secret
        ? getBookingDocumentBySecret({ secret, bookingId, documentId })
        : getTripDocument({ tripId, conversationId, documentId });
    }
    return getBookingDocument({ bookingId: decodeId(bookingId), documentId });
  };
  return (
    <KoobCard>
      {documents?.length > 0 ? (
        <div className="-my-5 flex flex-col divide-y">
          {documents.map((document, key) => (
            <DocumentListItem
              document={document}
              getDocument={getDocument}
              key={key}
            />
          ))}
        </div>
      ) : documents ? (
        <div>No docs</div>
      ) : (
        [...Array(5)].map((_e, key) => (
          <KoobPlaceholder className="h-12 my-1" key={key} />
        ))
      )}
    </KoobCard>
  );
}
